import { Injectable } from '@angular/core';
import { GoogleMapsModule } from './modules/google-maps.module';
import { GoogleMapsStateReadyFactory } from './factories/google-maps.ready-state.factory';
import { GoogleMapsViewModel } from './google-maps.view-model';
import { GoogleMapConfigFactory } from './factories/google-maps.config.factory';

@Injectable({
  providedIn: GoogleMapsModule
})
export class GoogleMapsViewModelFactory {
  constructor(
    private googleMapsStateReadyFactory: GoogleMapsStateReadyFactory,
    private configFactory: GoogleMapConfigFactory
  ) {}

  create(): GoogleMapsViewModel {
    return new GoogleMapsViewModel(this.googleMapsStateReadyFactory, this.configFactory);
  }
}
